module.exports = __webpack_public_path__ + "57a1dd301cfbe0654e2d642295d2c151.png";